import React, { useEffect, useMemo, useRef, useState } from 'react'
import StackedBar from './ScenarioChartD3'

const ComparisonChartD3 = props => {
  const { dataWhatIf, classDraw, type, ref, dataWhatIfCalculate } = props

  const chartArea = useRef(null)
  const [chart, setChart] = useState(null)
  const [chartSet, setChartSet] = useState(null)
  const [dataRanked, setDataRanked] = useState({})

  const getColorByRankValue = (data, type) => {
    let color = 'gray'
    if (type === 'asset_market_value') {
      if (data?.ranked && data[25] && data?.ranked <= data[25]) {
        color = '#DE313180'
      } else if (
        data?.ranked &&
        data[100] &&
        data[25] &&
        data?.ranked <= parseFloat(data[100]) + parseFloat(data[25])
      ) {
        color = '#FF6B0080'
      } else if (
        data?.ranked &&
        data[25] &&
        data[100] &&
        data[50] &&
        data?.ranked <=
          parseFloat(data[100]) + parseFloat(data[25]) + parseFloat(data[50])
      ) {
        color = '#FFC42C'
      } else {
        color = '#2FA26580'
      }
    } else {
      if (data?.ranked && data[25] && data?.ranked <= data[25]) {
        color = '#2FA26580'
      } else if (
        data?.ranked &&
        data[100] &&
        data[25] &&
        data?.ranked <= parseFloat(data[100]) + parseFloat(data[25])
      ) {
        color = '#FFC42C'
      } else if (
        data?.ranked &&
        data[25] &&
        data[100] &&
        data[50] &&
        data?.ranked <=
          parseFloat(data[100]) + parseFloat(data[25]) + parseFloat(data[50])
      ) {
        color = '#FF6B0080'
      } else {
        color = '#DE313180'
      }
    }

    return color
  }

  const dataValue = useMemo(() => {
    let dataValue = []
    if (dataWhatIf?.what_if_box && dataWhatIf?.what_if_box[type]) {
      Object.keys({ ...dataWhatIf }?.what_if_box[type])
        // .filter(it => it !== 'ranked')
        .forEach(it => {
          if (it == '25') {
            dataValue[0] = {
              label: '25th',
              value: parseFloat(dataWhatIf?.what_if_box[type][it] ?? 0) * 100,
            }
          }
          if (it == '100') {
            dataValue[1] = {
              label: '',
              value: parseFloat(dataWhatIf?.what_if_box[type][it] ?? 0) * 100,
            }
          }
          if (it == '50') {
            dataValue[2] = {
              label: '50th',
              value: parseFloat(dataWhatIf?.what_if_box[type][it] ?? 0) * 100,
            }
          }
          if (it == '75') {
            dataValue[3] = {
              label: '75th',
              value: parseFloat(dataWhatIf?.what_if_box[type][it] ?? 0) * 100,
            }
          }
          if (it == 'ranked') {
            setDataRanked(prev => ({
              ...prev,
              rankInit: {
                value: parseFloat(dataWhatIf?.what_if_box[type][it] ?? 0) * 100,
                color: null,
              },
            }))
          }
        })
    }
    return dataValue
  }, [dataWhatIf?.what_if_box])

  useEffect(() => {
    if (
      dataWhatIfCalculate?.what_if_box &&
      dataWhatIfCalculate?.what_if_box[type]
    ) {
      Object.keys({ ...dataWhatIfCalculate }?.what_if_box[type])
        .filter(it => it === 'ranked')
        .forEach(it => {
          if (it == 'ranked') {
            setDataRanked(prev => ({
              ...prev,
              rankCalculate: {
                value:
                  parseFloat(dataWhatIfCalculate?.what_if_box[type][it] ?? 0) *
                  100,
                color: getColorByRankValue(
                  dataWhatIfCalculate?.what_if_box[type],
                  type,
                ),
              },
            }))
          }
        })
      // setChart(null)
      // if (chart) {
      //   chart.clearChart()
      // }
      // if (chart) {
      //   chart.clearCircleCalculateChart(type)
      // }
    } else {
      if (chart) {
        chart.clearCircleCalculateChart('all')
      }
    }
  }, [dataWhatIfCalculate])

  useEffect(() => {
    if(dataValue?.length > 0) {
      if (!chart) {
        setChart(
            new StackedBar(chartArea.current, dataValue, dataRanked, classDraw),
        )
      } else if (chartSet) {
        chart.update(chartArea.current, dataValue, dataRanked, classDraw)
      }
    }

  }, [chart, chartSet, dataValue, dataRanked])

  // screen size
  useEffect(() => {
    if (chartArea && chart) {
      const { offsetWidth, offsetHeight } = chartArea.current.parentElement
      chart.setDimensions(offsetWidth - 5, offsetHeight)
      setChartSet(true)
    }
  }, [chartArea, chart])

  return <div className={classDraw} ref={chartArea} />
}

export default ComparisonChartD3
